/* eslint-disable react/react-in-jsx-scope,react/display-name,react/jsx-no-undef,keyword-spacing */
import React from 'react'
import Zergling from '../helpers/zergling';
import { OpenPopup, ClosePopup, checkedTickets, finishLoading, checkCashoutTicket, OpenIdlePopup, SetStackerFull } from "../actions/ui";
import {
  TerminalError, LockTerminal, UnlockTerminal, HideTerminalError, SetProfileError,
  SetCurrency, ShowKeyboard, SetTerminalAuthData, UserDidLogin, HandleMousePosition, SetStartupSettings, ShowLastBetsList, IsAdminLoggedIn,
  RegisterMode, IsCardRegistered, ClearCardRegistered, LoyalCard, PrintLotteryTickets
} from "../actions/terminal";
import { browserHistory } from 'react-router';
import { BetslipClear } from "../actions/betslip";
import Config from '../config/main';
import Helpers from "../helpers/helperFunctions";
import { LoggedIn, Logout } from "../actions/login";
import cookie from 'react-cookie';
import { t } from "./translator";
import { registerFromCSharp } from '../terminal/components/dmsRegisterFields';
import { updateFromCSharp } from '../terminal/components/dmsRegUpdateConfirmation';
import { getCasinoBetsInfo, processBarcode } from './tickets';
import { getSwarmRfidPinLoginNeededRequest } from '../helpers/terminalRequests/rfid';
import { SetRestrictedMode } from '../actions/admin';
import { BonusesNotification } from '../terminal/components/bonusesNotification';
import { toast } from 'react-toastify'
import { SET_DEPOSIT_MODE } from '../actions/actionTypes';
import { SuccessStatusesEnum } from '../constants/enums/successStatuses';
import { PreferencesSet } from '../actions';
import IdleService from '../services/idle';
import { checkForStaffPass } from '../terminal/components/staffLoginPopup';
import { broadcast, broadcastChannels } from './broadcast';

const setupTerminalFunctionalities = (store) => {
  let currency = Helpers.getUriParam("currency"),
    authData = sessionStorage.getItem('authData') && JSON.parse(sessionStorage.getItem('authData'));
  currency && store.dispatch(SetCurrency(currency));

  return new Promise((resolve) => {
    // Functions for app --> (in windows)
    (() => {
      window.jsobject = window.jsobject || window.external || {};
      let noop = () => {
      };

      if (!window.jsobject.reload) {
        window.jsobject.reload = () => window.location.reload();
      }

      if (!window.jsobject.tellAboutException) {
        window.jsobject.tellAboutException = (data) => {
          console.log('printing', data);
        };
      }
      if (!window.jsobject.rfidRegisterMode) {
        window.jsobject.rfidRegisterMode = (mode, data) => {
          console.log('rfidRegisterMode', mode)
          console.log('name', data)
        }
      }

      if (!window.jsobject.adminUserCommands) {
        window.jsobject.adminUserCommands = (command, payload) => {
          console.log('adminUserCommands', payload);
          console.log('command', command);
        }
      }
      if (!window.jsobject.printTicket) {
        window.jsobject.printTicket = (data) => {
          console.log('printing', data);
        };
      }
      if (!window.jsobject.printBetBuilderTicket) {
        window.jsobject.printBetBuilderTicket = (data) => {
          console.log('printing bet builder', data);
        };
      }
      if (!window.jsobject.titoAcceptCasinoBet) {
        window.jsobject.titoAcceptCasinoBet = (transactionId, winAmount, userData, tax) => {
          console.log('titoAcceptCasinoBet', transactionId, winAmount, userData, tax);
        };
      }
      if (!window.jsobject.printBookingTicket) {
        window.jsobject.printBookingTicket = (data) => {
          console.log('printBookingTicket', data);
        };
      }
      if (!window.jsobject.getNetworkTime) {
        window.jsobject.getNetworkTime = () => {
          window.setNetworkTime(Date.now());
          console.log('getNetworkTime');
        };
      }
      if (!window.jsobject.casinoGamesPageOpened) {
        window.jsobject.casinoGamesPageOpened = () => {
          console.log('casinoGamesPageOpened');
        };
      }
      if (!window.jsobject.printClientTicket) {
        window.jsobject.printClientTicket = (data) => {
          console.log('printing client ticket', data);
        };
      }
      if (!window.jsobject.printLotteryTickets) {
        window.jsobject.printLotteryTickets = (data, isCopy) => {
          console.log('printing lottery ticket', data, isCopy);
        };
      }
      if (!window.jsobject.getLastTicketById) {
        window.jsobject.getLastTicketById = (id) => {
          console.log('printing', id);
        };
      }
      if (!window.jsobject.getSuperbetTicketById) {
        window.jsobject.getSuperbetTicketById = (id) => {
          console.log('superbet ID', id);
        };
      }
      if (!window.jsobject.setSuperBetId) {
        window.jsobject.setSuperBetId = (id) => {
          console.log('superbet ID', id);
        };
      }
      if (!window.jsobject.rejectSuperbet) {
        window.jsobject.rejectSuperbet = (id) => {
          console.log('Reject Superbet, ID - ', id);
        };
      }
      if (!window.jsobject.setTax) {
        window.jsobject.setTax = (taxType, taxPersent) => {
          console.log('set TAX', taxType, taxPersent);
        };
      }
      if (!window.jsobject.printLastPayedTickets) {
        window.jsobject.printLastPayedTickets = () => {
          console.log('print last payed tickets');
        };
      }
      if (!window.jsobject.setType) {
        window.jsobject.setType = noop;
      }
      if (!window.jsobject.withdraw) {
        window.jsobject.withdraw = (type) => {
          console.log(' withdraw terminal balance', type, ':');
        };
      }
      if (!window.jsobject.withdrawWithFee) {
        window.jsobject.withdrawWithFee = (type) => {
          console.log(' withdrawWithFee terminal balance', type, ':');
        };
      }
      if (!window.jsobject.withdrawClientBalance) {
        window.jsobject.withdrawClientBalance = () => {
          console.log('withdraw client balance from terminal');
        };
      }
      if (!window.jsobject.setSecondScreenUrl) {
        window.jsobject.setSecondScreenUrl = (url) => {
          console.log('setSecondScreenUrl', url);
        };
      }

      if (!window.jsobject.setLanguage) {
        window.jsobject.setLanguage = (language) => {
          console.log('setLanguage', language);
        };
      }

      if (!window.jsobject.userDidLogin) {
        window.jsobject.userDidLogin = (userId, userCurrency) => {
          console.log('printing did login', userId, userCurrency);
        };
      }

      if (!window.jsobject.userDidLogout) {
        window.jsobject.userDidLogout = () => {
          console.log('userDidLogout');
        };
      }

      if (!window.jsobject.registerMode) {
        window.jsobject.registerMode = (bool) => {
          console.log(`registerMode is ${bool}`);
        };
      }

      if (!window.jsobject.inspectElement) {
        window.jsobject.inspectElement = () => {
          console.log('inspect Element');
        };
      }
      if (!window.jsobject.openLastLogFile) {
        window.jsobject.openLastLogFile = () => {
          console.log('open Last Log File');
        };
      }
      if (!window.jsobject.openDmsLastTicketDialog) {
        window.jsobject.openDmsLastTicketDialog = () => {
          console.log('open DMS Last Ticket Dialog');
        };
      }

      if (!window.jsobject.openAdminPage) {
        window.jsobject.openAdminPage = () => {
          console.log('open Admin Page');
        };
      }

      if (!window.jsobject.titoAcceptBet) {
        window.jsobject.titoAcceptBet = (bet, amount, taxAmount) => {
          console.log('accept bet', bet, "amount = ", amount, "tax amount = ", taxAmount);
          window.barcodeBuffer = [];
        };
      }
      if (!window.jsobject.titoCashoutBet) {
        window.jsobject.titoCashoutBet = (barcode, amount) => {
          console.log('titoCashoutBet ------------', barcode, amount);
          window.barcodeBuffer = [];
        };
      }
      if (!window.jsobject.titoAcceptCashout) {
        window.jsobject.titoAcceptCashout = (barcode) => {
          console.log('accept cashout-----------------------------', barcode);
        };
      }

      if (!window.jsobject.titoAcceptBoPayment) {
        window.jsobject.titoAcceptBoPayment = () => {
          console.log('accept bo payment');
        };
      }

      if (!window.jsobject.confirmUserId) {
        window.jsobject.confirmUserId = () => {
          console.log('confirm User Id');
        };
      }

      if (!window.jsobject.confirmDeposit) {
        window.jsobject.confirmDeposit = () => {
          console.log('confirm Deposit');
        };
      }

      if (!window.jsobject.cancelBillAcceptor) {
        window.jsobject.cancelBillAcceptor = () => {
          console.log('cancel Bill Acceptor');
        };
      }

      if (!window.jsobject.getCurrency) {
        window.jsobject.getCurrency = () => {
          console.log('get currency');
        };
      }

      if (!window.jsobject.appReady) {
        window.jsobject.appReady = () => {
          console.log('app ready');
        };
      }

      if (!window.jsobject.lockTerminal) {
        window.jsobject.lockTerminal = () => {
          console.log('lock terminal admin');
        };
      }

      if (!window.jsobject.isAdminLoggedIn) {
        window.jsobject.isAdminLoggedIn = () => {
          console.log('admin logged in');
        };
      }
      if (!window.jsobject.cardRegistered) {
        window.jsobject.cardRegistered = () => {
          console.log('Card registered');
        };
      }

      if (!window.jsobject.isCardRegistered) {
        window.jsobject.isCardRegistered = (id, bool) => {
          console.log(`register new card ${id}, is registered ${bool}`);
        };
      }
      if (!window.jsobject.confirmRegistrationNewCard) {
        window.jsobject.confirmRegistrationNewCard = (barcode) => {
          console.log(`registration is done, rfid is ${barcode}`);
        };
      }
      if (!window.jsobject.updatePlayerCardId) {
        window.jsobject.updatePlayerCardId = () => {
          console.log(`Card ID is updated`);
        };
      }

      if (!window.jsobject.upperScreen) {
        window.jsobject.upperScreen = (data, id, url, providerID) => {
          console.log('upperScreen', data, id, url, providerID);
        };
      }

      if (!window.jsobject.unlockTerminal) {
        window.jsobject.unlockTerminal = () => {
          console.log('unlock terminal admin');
        };
      }

      if (!window.jsobject.stackerCollection) {
        window.jsobject.stackerCollection = () => {
          console.log('stacker collection');
        };
      }

      if (!window.jsobject.setBalance) {
        window.jsobject.setBalance = (balance) => {
          console.log('the balance', balance);
        };
      }

      if (!window.jsobject.titoCashoutBetFromTicketsBoard) {
        window.jsobject.titoCashoutBetFromTicketsBoard = () => {
          console.log('Tito cashout bet from tickets board')
        }
      }

      if (!window.jsobject.adminPageWasOpened) {
        window.jsobject.adminPageWasOpened = () => {
          console.log('admin page was opened');
        };
      }

      if (!window.jsobject.printLastTicket) {
        window.jsobject.printLastTicket = () => {
          console.log('print last bet ticket');
        };
      }

      if (!window.jsobject.printLastCashoutTicket) {
        window.jsobject.printLastCashoutTicket = () => {
          console.log('print last cash out ticket');
        };
      }

      if (!window.jsobject.printLastPaidTickets) {
        window.jsobject.printLastPaidTickets = () => {
          console.log('print last paid tickets');
        };
      }

      if (!window.jsobject.logoutUser) {
        window.jsobject.logoutUser = () => {
          console.log('logout user');
        };
      }

      if (!window.jsobject.stackerBalance) {
        window.jsobject.stackerBalance = () => {
          console.log('stacker balance');
        };
      }

      if (!window.jsobject.getLastTickets) {
        window.jsobject.getLastTickets = (data) => {
          console.log('last tickets ' + data);
        };
      }

      if (!window.jsobject.getLastPaidTickets) {
        window.jsobject.getLastPaidTickets = (date) => {
          console.log('last payed tickets ' + date);
        };
      }

      if (!window.jsobject.todaysReport) {
        window.jsobject.todaysReport = (data) => {
          console.log('todays report ' + data);
        };
      }

      if (!window.jsobject.multipleDaysReport) {
        window.jsobject.multipleDaysReport = (data) => {
          console.log('todays report ' + data);
        };
      }

      if (!window.jsobject.resetBillAcceptor) {
        window.jsobject.resetBillAcceptor = () => {
          console.log('reset bill acceptor');
        };
      }

      if (!window.jsobject.showDeviceStatuses) {
        window.jsobject.showDeviceStatuses = () => {
          console.log('show device status');
        };
      }
      if (!window.jsobject.checkHoppersErrorsAndStates) {
        window.jsobject.checkHoppersErrorsAndStates = () => {
          console.log('Check Hoppers errors and states');
        };
      }

      if (!window.jsobject.calibration) {
        window.jsobject.calibration = () => {
          console.log('calibration');
        };
      }

      if (!window.jsobject.hopper1Refill) {
        window.jsobject.hopper1Refill = (count) => {
          console.log('hopper 1' + ' value: ' + count);
        };
      }

      if (!window.jsobject.hopper2Refill) {
        window.jsobject.hopper2Refill = (count) => {
          console.log('hopper 2' + ' value: ' + count);
        };
      }

      if (!window.jsobject.resetDeviceConnections) {
        window.jsobject.resetDeviceConnections = () => {
          console.log('reset device connections');
        };
      }

      if (!window.jsobject.lastEnteredBillsAndCoins) {
        window.jsobject.lastEnteredBillsAndCoins = () => {
          console.log('last entered bill and coins');
        };
      }

      if (!window.jsobject.scanBarcode) {
        window.jsobject.scanBarcode = () => {
          console.log('Scan barcode');
        };
      }

      if (!window.jsobject.shutDown) {
        window.jsobject.shutDown = () => {
          console.log('shut down');
        };
      }

      if (!window.jsobject.rebootPC) {
        window.jsobject.rebootPC = () => {
          console.log('reboot PC');
        };
      }

      if (!window.jsobject.closeApplication) {
        window.jsobject.closeApplication = () => {
          console.log('close application ');
        };
      }

      if (!window.jsobject.loginAdmin) {
        window.jsobject.loginAdmin = (username, password) => {
          console.info("Login admin - ", username, password);
        };
      }
      if (!window.jsobject.exitAdmin) {
        window.jsobject.exitAdmin = () => {
          return true;
        };
      }

      if (!window.jsobject.setIdle) {
        window.jsobject.setIdle = (url) => {
          console.log('printing idle', url);
        };
      }
      if (!window.jsobject.setNotIdle) {
        window.jsobject.setNotIdle = (url) => {
          console.log('printing not idle', url);
        };
      }
      if (!window.jsobject.setVirtualVideo) {
        window.jsobject.setVirtualVideo = (url, providerId, id) => {
          console.log('printing set virtual video', url, providerId, id);
        };
      }
      if (!window.jsobject.adminPageExit) {
        window.jsobject.adminPageExit = () => {
          console.log('admin Page Exit');
        };
      }
      if (!window.jsobject.openTerminalIdDialog) {
        window.jsobject.openTerminalIdDialog = () => {
          console.log('open Terminal Id Dialog');
        };
      }
      if (!window.jsobject.touchPosition) {
        window.jsobject.touchPosition = (x, y) => {
          console.log(`touch position --> x:${x}, y:${y}`);
        };
      }
      if (!window.jsobject.cardDeposit) {
        window.jsobject.cardDeposit = (data) => {
          console.log(data, "amount");
        };
      }

      if (!window.jsobject.loginAdmin) {
        window.jsobject.loginAdmin = (username, password) => {
          console.log('login admin' + username, password);
        };
      }
      if (!window.jsobject.showStackerBalance) {
        window.jsobject.showStackerBalance = () => {
          console.log('show stacker balance');
        };
      }
      if (!window.jsobject.depositToClientAccount) {
        window.jsobject.depositToClientAccount = (data) => {
          console.log('depositToClientAccount --- ' + data)
        }
      }
      if (!window.jsobject.sendLogs) {
        window.jsobject.sendLogs = (data) => {
          console.log('send Log ---> ' + data);
        };
      }
      if (!window.jsobject.bulkTitoOperation) {
        window.jsobject.bulkTitoOperation = (data) => {
          console.log('bulkTitoOperation ---> ' + data);
        };
      }
      if (!window.depositAmount) {
        window.depositAmount = () => {
          console.log('deposit amount');
        };
      }
      window.preventDrags = () => [...document.getElementsByTagName('A')].forEach(t => { t.ondragstart = function () { return false; }; });
      window.setInterval(() => {
        if (document.activeElement.tagName.toLowerCase() === "a" || document.activeElement.tagName.toLowerCase() === "button") {
          document.activeElement.blur();
        }
      }, 1000);
      window.onbeforeunload = () => {
        let storeState = store.getState(),
          loggedIn = storeState.user.loggedIn,
          reallyLoggedIn = storeState.user.reallyLoggedIn;
        (loggedIn && reallyLoggedIn) && cookie.remove("authData");
        localStorage.removeItem("reduxPersist:favorites");
        localStorage.removeItem("reduxPersist:persistentUIState");
      };
      window.SetToken = (token) => {
        let params = { ...authData };
        params.token = token;
        sessionStorage.setItem('authData', JSON.stringify(params));
        store.dispatch(SetTerminalAuthData({ 'authData': params }));
      };

      window.emptyBetslip = () => {
        store.dispatch(BetslipClear());
      };

      window.setDepositMode = (depositMode) => {
        store.dispatch({
          type: SET_DEPOSIT_MODE,
          depositMode
        })
      }

      window.setLanguageFromMainApp = langCode => {
        store.dispatch(PreferencesSet("lang", langCode));
        setTimeout(() => window.location.reload(), 0);
      }
      window.cardDepositResult = (response) => {
        if (response.Success) {
          store.dispatch(OpenPopup(
            'successPopup',
            {
              title: 'Deposit by bank card',
              subTitle: 'The transaction was successfully done'
            }
          ))
        } else {
          store.dispatch(OpenPopup('errorPopup', { errorMessage: response.Message?.split?.("=> ")[1] }))
        }
      }
      window.disablePOSInput = (response) => {
        // if (response.Success) {
        //     store.dispatch(OpenPopup('adminScanSuccess', { verificationType: 'rfid' }))
        // } else {
        //     store.dispatch(OpenPopup('errorPopup', { errorMessage: response.Message }))
        // }
      }

      window.openGameDetails = gameData => {
        const { popupParams } = store.getState().uiState;
        if (popupParams?.disable) return;

        try {
          const data = JSON.parse(gameData);
          const { sportAlias, regionId, competitionId, gameId } = data;

          browserHistory.push(`/live/${sportAlias}/${regionId}/${competitionId}/${gameId}`);
          console.log('Open game details');
        } catch { console.log('Invalid data to open game details'); }
      };

      window.openCompetitionDetails = competitionData => {
        const { popupParams } = store.getState().uiState;
        if (popupParams?.disable) return;

        try {
          const data = JSON.parse(competitionData);
          const { sportAlias, regionId, competitionId } = data;

          browserHistory.push(`/prematch/${sportAlias}/${regionId}/${competitionId}`);
          console.log('Open competition details');
        } catch { console.log('Invalid data to open competition details'); }
      };

      window.showUiErrorToast = (text) => {
        toast.error(`${t("DEPOSITING WITH CASH MONEY IS CURRENTLY UNAVAILABLE")} (${text})`, {
          icon: <div className='toast-error-icon' />,
          position: toast.POSITION.BOTTOM_CENTER,
          hideProgressBar: true,
          draggable: false,
          closeButton: false,
          closeOnClick: false,
          autoClose: false,
          toastId: 'stacker-full-toast',
          className: 'toast-custom-error'
        });
      }

      window.lockScreen = (text) => {
        store.dispatch(LockTerminal(text));
      };

      if (Config.enableTouchPositionIniFrames) {
        window.addEventListener('message', processMessage, false);
        // eslint-disable-next-line no-inner-declarations
        function processMessage(message) {
          if ("data" in message) {
            if (typeof message.data === 'string') {
              try {
                let dataJson = JSON.parse(message.data);
                window.jsobject.touchPosition(dataJson.BGTouch.x, dataJson.BGTouch.y);
              } catch (e) {
                return;
              }
            } else if (message.data.type && message.data.type === "BGTouch") {
              try {
                window.jsobject.touchPosition(message.data.position.x, message.data.position.y);
              } catch (e) {
                return;
              }
            }
          }
        }
      }
      window.isAdminLoggedIn = (bool) => {
        store.dispatch(IsAdminLoggedIn(bool));

        setTimeout(() => {
          store.dispatch(IsAdminLoggedIn(false));
        }, 20000);
      };
      window.cardRegistered = (params, isSuccess) => {
        registerFromCSharp(params, isSuccess);
      };
      window.cardUpdated = (params, bool) => {
        updateFromCSharp(params, bool);
      };
      window.setProfileError = (text) => {
        store.dispatch(SetProfileError(text));
      };
      window.registerMode = (bool) => {
        store.dispatch(RegisterMode(bool));
      };
      window.clearCardRegistered = () => {
        store.dispatch(ClearCardRegistered());
      };
      window.isCardRegistered = (id, bool) => {
        // if(bool) {
        //     let token = JSON.parse(sessionStorage.getItem("authData")).token;
        //     Zergling.get({"token": token, "filter": {"rfid": id}},
        //         "terminal_find_player")
        //         .then(response => {
        //             if(!response.data) {
        //                 console.warn("response.data must be array");
        //             }
        //             store.dispatch(IsCardRegistered({id, bool: !response.data.length}));
        //         });
        // }else {
        //     store.dispatch(IsCardRegistered({id, bool: false}));
        // }

        store.dispatch(IsCardRegistered({ id, bool }));
      };
      window.confirmOnAction = (type, info = "{}") => {
        switch (type) {
          case "CashoutBetFailed":
            processBarcode(`000${(JSON.parse(info)).barcode}`);
            break;
          case "EarlyCashoutSucceed":
            store.dispatch(OpenPopup('userActionOK', { data: t(Config.textsPopupAfterActions[type]) }));
            break;
          case "SuperBetAccepted":
            store.dispatch(OpenPopup("superbet", { disable: true, superBetIsAlreadyAccepted: true }));
            break;
          case "SuperBetRejected":
            store.dispatch(OpenPopup("superbet", { disable: true, superBetIsAlreadyAccepted: false }));
            break;
          case "BetNotFound":
            store.dispatch(TerminalError(t("Bet not found")));
            break;
          case "DepositToClientAccountSucceed":
            store.dispatch(OpenPopup(
              'successPopup',
              {
                title: 'Transfer to Account',
                subTitle: 'The transfer was successfully done.\nPlease take your ticket'
              }
            ))
            break;
          case "CashoutWithFeeSucceed":
            store.dispatch(OpenPopup(
              'successPopup',
              {
                title: 'Cash Out',
                subTitle: 'Cash out was successfully done.\nPlease take your ticket'
              }
            ))
            break;
          default:
            Config.showPopupAfterActions && store.dispatch(OpenPopup('userActionOK', { data: t(Config.textsPopupAfterActions[type]) }));
            break;
        }
      };
      window.testMethod = () => {
        var obj = [{ igor: true }, { arman: true }, { sahak: false }];
        const promise = new Promise(function (resolve, reject) {
          setTimeout(function () {
            resolve(obj);
          }, 5000);
        });
        promise.then(val => {
          val;
        });
        return promise;
      };
      window.testMethod2 = () => {
        var obj = [{ igor: true }, { arman: true }, { sahak: false }];
        return obj;
      };
      window.bulkTitoOperationCustomResult = () => {};
      window.bulkTitoOperationResult = (data) => {
        store.dispatch(checkedTickets(data));
      };
      window.bulkTitoOperationComplited = (bool) => {
        store.dispatch(finishLoading(bool));
      };
      window.earlyCashoutResult = (data) => {
        try {
          // In case when data.Data is a JSON
          const result = JSON.parse(data.Data);
          if (typeof result === 'object')
            data.Data = result;
        } catch { /* nope */ }

        return store.dispatch(checkCashoutTicket(data));
      };
      window.openIdleTimePopup = () => {
        if (Config.popupForTerminalInactivity) {
          store.dispatch(OpenIdlePopup());
        } else {
          console.log("PopupForTerminalInactivity is disabled");
        }
      };
      window.terminalLockReminder = (data) => {
        if (Config.popupForTerminalLock) {
          store.dispatch(OpenPopup("terminalLockReminder", { data }));
        } else {
          console.log("PopupForTerminalLock is disabled");
        }
      };
      window.unlockScreen = () => {
        toast.dismiss('stacker-full-toast')

        store.dispatch(UnlockTerminal(null));
      };
      window.hideTerminalError = () => {
        store.dispatch(HideTerminalError(null));
      };
      window.getLotteryTicketInfoByExternalId = async (ExternalId) => {
        const isCopy = true;

        const [casinoData, swarmData] = await Promise.all([
          getCasinoBetsInfo([ExternalId]),

          Zergling.get({
            CashdeskId: JSON.parse(sessionStorage.getItem("authData")).tid,
            token: JSON.parse(sessionStorage.getItem("authData")).token,
            ExternalId: ExternalId,
            IsWithAdditionalInfo: true
          }, "terminal_get_casino_bets")
        ]);

        const ticketInfo = casinoData.Data[0];

        if (!ticketInfo || !swarmData.Data[0])
          return store.dispatch(TerminalError(t("Bet not found")));


        swarmData.Data[0].possible_tax_amount = ticketInfo.PossibleTaxAmount;
        store.dispatch(PrintLotteryTickets(JSON.stringify(swarmData.Data[0]), isCopy));
      };
      window.forceLogout = () => {
        store.dispatch(LoyalCard(null));
        let storeState = store.getState();
        let loggedIn = storeState.user && storeState.user.loggedIn;
        if (loggedIn) {
          store.dispatch(Logout());
        }
      };
      window.OpenAdminLogin = () => {
        store.dispatch(OpenPopup("LoginForm", { signInToAdmin: true }));
      };
      window.sendStackerBalance = (text) => {
        store.dispatch(OpenPopup('showStackerBalance', { data: text }));
      };
      window.showTerminalError = (error, close) => {
        store.dispatch(TerminalError({ error, close }));
      };
      window.showLastBetsList = (tickets) => {
        store.dispatch(ShowLastBetsList(tickets));
      };
      window.openAdminPage = (restrictedMode) => {
        const path = restrictedMode ? '/admin?restrictedMode=true' : '/admin';
        browserHistory.push(path);
        console.info("Open admin page");
      };
      window.isMainPage = () => {
        if (window.location.pathname === "/") {
          return true;
        } else {
          return false;
        }
      };
      window.confirmAction = (actionType) => {
        alert(actionType)
        switch (actionType) {
          case SuccessStatusesEnum.CashoutWithFeeSucceed:
            store.dispatch(OpenPopup(
              'successPopup',
              {
                title: 'Cash Out',
                subTitle: 'Cash out was successfully done.\nPlease take your ticket'
              }
            ))
            break;
          case SuccessStatusesEnum.
            default:
            return
        }
      }
      window.paymentPopupState = (bool) => {
        store.dispatch(bool ? OpenPopup("showPaymentPopup", { disable: true }) : ClosePopup("showPaymentPopup"));
      };
      window.tellUILastPaidTicketsCount = count => {
        store.dispatch(OpenPopup('adminPayedTicketsCount', { count }));
      };

      window.showUIToast = (type, message) => {
        toast[type]?.(message);
      };

      window.setNetworkTime = isoString => {
        broadcast.dispatchEvent(new CustomEvent(broadcastChannels.NetworkTimeChange, { detail: isoString }));
      };


      window.SignInByRFID = async rfid => {
        let tid = JSON.parse(sessionStorage.getItem("authData")).tid,
          state = store.getState(),
          scanBarcode = !(state.uiState.popupParams !== undefined) || !(state.uiState.popupParams !== null) || (!state.uiState.popupParams.disable);

        if (!state.user.loggedInByRFID) {
          if (Config.main.rfidPinCode) {
            const pinNeededResult = await Zergling.get(getSwarmRfidPinLoginNeededRequest({ Rfid: rfid }), 'betshop_command');
            if (pinNeededResult?.data?.IsNeeded) return store.dispatch(OpenPopup('dmsLoginPinCode', { rfid }));
          }

          Zergling.get({
            card_number: rfid,
            cashdesk: tid
          }, "rfid_login").then((data) => {
            store.dispatch(LoggedIn({ authData: data, rfid, loggedInByRFID: true }));
            store.dispatch(UserDidLogin({ userId: data.user_id, currency: JSON.parse(sessionStorage.getItem("authData")).currency }));

            Config.rfid.logoutIfIdleSecondsCount &&
              IdleService.ifInactive(Config.rfid.logoutIfIdleSecondsCount, () => {
                store.dispatch(Logout(true));
                store.dispatch(ClosePopup());
              });

            Zergling.get({ free_bonuses: true }, 'get_bonus_details')
              .then(data => {
                if (data.bonuses?.length)
                  toast.info(<BonusesNotification bonuses={data.bonuses} currency={authData.currency} />)
              })
          }).catch(() => {
            store.dispatch(OpenPopup('errorLoggedInRFID', { text: "Invalid RFID card" }));
          });
        } else if (scanBarcode) {
          store.dispatch(OpenPopup('errorLoggedInRFID', { text: "Sorry, but you can't open new session before closing the previous one" }));
        }
      };
      window.SignOutRF = () => {
        !Config.terminal.enableSignOutWithRfidButton && store.dispatch(Logout());
      };
      window.openMainPage = () => {
        console.info("Open main page");
      };
      window.barcodeEnter = (barcode) => {
        const inLockedState = store.getState().uiState.popupParams && store.getState().uiState.popupParams.disable;

        if (!inLockedState) {
          processBarcode(barcode);
        }
      };
      window.getLanguage = noop;

      window.setStartupSettings = settings => {
        store.dispatch(SetStartupSettings(settings));
      }

      window.setMinMax = (min, max) => {
        store.dispatch(SetStartupSettings({ MinBet: min, MaxBet: max }));
      };

      window.getAdminUserBarcodeResponse = (response) => {
        if (response.Success) {
          window.openAdminPage(true)
          window.jsobject.adminPageWasOpened();
        } else {
          const errorMessage = response.Code === 11003
            ? 'Admin is not found'
            : response.Message

          store.dispatch(OpenPopup('errorPopup', { errorMessage }))
        }
      }
    })();

    // Event listeners

    (() => {
      window.barcodeBuffer = [];
      window.addEventListener('mousedown', (e) => {
        Config.main.enableFunctionalitySetMousePosition && store.dispatch(HandleMousePosition({ x: e.screenX, y: e.screenY }));
      });

      //on external iframe click window is beeing blured, for such cases we added this handler also:)
      // window.addEventListener('blur', () => {
      //     if (document.activeElement.tagName === "IFRAME") {
      //         Config.main.enableFunctionalitySetMousePosition && store.dispatch(HandleMousePosition({ x: 0, y: 0 }));
      //         setTimeout(window.focus, 0);
      //     }
      // });

      window.addEventListener('contextmenu', (window) => {
        window.preventDefault();
      }, false);
      window.addEventListener('keydown', async (e) => {
        if (e.altKey && e.keyCode === 82) { // alt+r
          window.jsobject.reload();
        } else if (e.altKey && e.keyCode === 73) { //alt+i
          const accepted = await checkForStaffPass();
          accepted && window.jsobject.inspectElement();
        } else if (e.altKey && e.keyCode === 65) { //alt+a
          const accepted = await checkForStaffPass();
          if (Config.AdminShortcutWithLoginOnly) {
            store.dispatch(OpenPopup("LoginForm", { signInToAdmin: true }));
          } else if (accepted) {
            window.openAdminPage();
            window.jsobject.adminPageWasOpened();
          }
        } else if (e.altKey && e.keyCode === 76) { //alt+l
          const accepted = await checkForStaffPass();
          accepted && window.jsobject.openLastLogFile();
        } else if (e.altKey && e.keyCode === 84) { //alt+t
          const accepted = await checkForStaffPass();
          accepted && window.jsobject.openTerminalIdDialog();
        } else if (e.altKey && e.keyCode === 67) { //alt+c
          window.jsobject.openDmsLastTicketDialog();
        }
      });

      if (!Config.main.disableKeyboardBarcodeCatch) {
        window.addEventListener('keypress', (e) => {
          let inLockedState = store.getState().uiState.popupParams && store.getState().uiState.popupParams.disable;
          if (!inLockedState) {
            if (+e.which !== 13) {
              clearTimeout(window.barcodeBufferTimer);
              window.barcodeBuffer.push(e.key);
              window.barcodeBufferTimer = setTimeout(() => {
                window.barcodeBuffer = [];
                window.barcodeBufferTimer = null;
              }, 2000);
            }
            if (+e.which === 13) {
              let barcodeBuffer = window.barcodeBuffer;
              let result = "";
              for (let i = 0; i < barcodeBuffer.length; i++) {
                result += barcodeBuffer[i];
              }
              processBarcode(result);
            }
          }
        });
      }
      window.addEventListener('message', (event) => {
        let action = event.data.action;
        if (action === 'openKeyboard') {
          window.liveCasinoEventSource = event.source;
          store.dispatch(ShowKeyboard(false));
          store.dispatch(ShowKeyboard(true));
        }
      }, false);
      var oldOnError = window.onerror;
      window.onerror = function () {
        if (oldOnError) {
          oldOnError.apply(this, arguments);
          //store.dispatch(SendLogs({msg, url, lineNo, columnNo, error: JSON.stringify(error)}));
        }
      };
    })();

    resolve();
  });
};

export default setupTerminalFunctionalities;
